'use strict';
angular.module('schoolLinqApp').factory('arInvoiceService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/arinvoice';

		function getArInvoicesForSend() {
			return $http.get(endpoint + '/listarinvoicesforsend');
		}

		function getArInvoiceImagePreview(arInvoiceId) {
			return $http.get(endpoint + '/getarinvoicepreviewimage', {
				params: { arInvoiceId: arInvoiceId },
			});
		}

		function emailArInvoice(arInvoicesToSend) {
			return $http.post(endpoint + '/emailarinvoice', arInvoicesToSend);
		}

		function checkInvoiceSendStatus(invoicesToSend) {
			return $http.post(endpoint + '/checkarinvoicesendstatus', invoicesToSend);
		}

		function getInvoice(id) {
			return $http.get(endpoint, { params: { id: id } });
		}

		function closeInvoice(id) {
			return $http.post(endpoint + '/close', null, { params: { id: id } });
		}

		function searchInvoices(filter) {
			return $http.get(endpoint + '/search', {
				params: {
					Ids: filter.Ids,
					StatusId: filter.statusId,
					FromDate: filter.fromDate,
					ToDate: filter.toDate,
					CustomerId: filter.customer && filter.customer.Id > 0 ? filter.customer.Id : null,
					UserName: filter.user && filter.user.UserName !== 'All Users' ? filter.user.UserName : null,
					SiteId: filter.site && filter.site.Id > 0 ? filter.site.Id : null,
				},
			});
		}

		function addInvoice(invoice) {
			return $http.put(endpoint, {
				...invoice,
				InvoiceDT: invoice.InvoiceDT.toDateString(),
				DueDT: invoice.DueDT.toDateString(),
			});
		}

		function updateInvoice(invoice) {
			return $http.post(endpoint + '/update', {
				...invoice,
				InvoiceDT: invoice.InvoiceDT.toDateString(),
				DueDT: invoice.DueDT.toDateString(),
			});
		}

		return {
			getArInvoicesForSend: getArInvoicesForSend,
			getArInvoiceImagePreview: getArInvoiceImagePreview,
			emailArInvoice: emailArInvoice,
			checkInvoiceSendStatus: checkInvoiceSendStatus,
			searchInvoices: searchInvoices,
			addInvoice: addInvoice,
			updateInvoice: updateInvoice,
			getInvoice: getInvoice,
			closeInvoice: closeInvoice,
		};
	},
]);
